// extracted by mini-css-extract-plugin
export var circle = "_31-2";
export var icon = "_31-a";
export var iconHighlight = "_31-0";
export var lg = "_31-8";
export var md = "_31-7";
export var outline = "_31-4";
export var sm = "_31-6";
export var square = "_31-1";
export var xl = "_31-9";
export var xs = "_31-5";
export var xxs = "_31-3";